import { gql } from '@apollo/client'

const BASE_ACHIEVEMENTS_FIELDS = gql`
  fragment BaseAchievementsFields on AchievementType {
    id
    isLive
    type
    amountRequired
    order
    awardType
    awardTypeValue
    description
    level
    platform {
      id
      title
      slug
    }
  }
`

export const FIND_ALL_ACHIEVEMENTS = gql`
  ${BASE_ACHIEVEMENTS_FIELDS}
  query findAllAchievements($query: AchievementQueryInput!) {
    findAllAchievements(query: $query) {
      ...BaseAchievementsFields
    }
  }
`
export const FIND_ACHIEVEMENT = gql`
  ${BASE_ACHIEVEMENTS_FIELDS}
  query findAchievement($id: String!) {
    findAchievement(id: $id) {
      ...BaseAchievementsFields
    }
  }
`

export const CREATE_ACHIEVEMENT = gql`
  ${BASE_ACHIEVEMENTS_FIELDS}
  mutation createAchievement($createAchievementInput: CreateAchievementInput!) {
    createAchievement(createAchievementInput: $createAchievementInput) {
      ...BaseAchievementsFields
    }
  }
`

export const UPDATE_ACHIEVEMENT = gql`
  ${BASE_ACHIEVEMENTS_FIELDS}
  mutation updateAchievement($updateAchievementInput: UpdateAchievementInput!) {
    updateAchievement(updateAchievementInput: $updateAchievementInput) {
      ...BaseAchievementsFields
    }
  }
`

export const BULK_UPDATE_ACHIEVEMENTS = gql`
  mutation bulkUpdateAchievements($bulkUpdateAchievementsInput: [BulkUpdateAchievementsInput!]!) {
    bulkUpdateAchievements(bulkUpdateAchievementsInput: $bulkUpdateAchievementsInput) {
      id
    }
  }
`
